<style scoped>
ul {
    counter-reset: item;
    @apply text-sm font-bold list-inside list-disc;
}

.ticket-content-box-wrapper {
    margin: 1rem 2% 1rem 2%;
}

.ticket-detail-content {
    overflow: auto;
    max-height: calc(100vh - 8rem);
}
</style>

<template>
    <div>
        <breadcrumb class="mt-4" :links="[{ msg: '門票' }]" />

        <div v-if="loading" class="my-8 flex justify-center">
            <spinner />
        </div>

        <div v-else-if="hasTicket" class="ticket-content-box-wrapper">
            <div class="text-secondary">
                <button
                    v-if="false"
                    class="px-2 focus:outline-none border-r border-secondary"
                    :class="{ 'text-darkGrayishBlue': filter === 'all' }"
                    @click="filter = 'all'"
                >
                    {{ '所有門票' }}
                </button>
                <button
                    class="px-2 focus:outline-none border-r border-secondary"
                    :class="{ 'text-darkGrayishBlue': filter === 'active' }"
                    @click="filter = 'active'"
                >
                    {{ '有效門票' }}
                </button>
                <button
                    class="px-2 focus:outline-none "
                    :class="{
                        'text-darkGrayishBlue': filter === 'inactive'
                    }"
                    @click="filter = 'inactive'"
                >
                    {{ '已使用或無效' }}
                </button>
            </div>
            <div class="border border-gray-100 p-1 md:p-10 mt-2">
                <div class="w-full flex flex-col items-center">
                    <div
                        v-for="(t, ti) in recordsInPage"
                        :key="ti"
                        class="w-full py-8 border-b border-dotted border-gray-100 flex flex-col sm:flex-row sm:items-center"
                    >
                        <div class="w-full sm:w-1/2 flex-shrink-0">
                            <div class="my-2 text-xl font-semibold">
                                <div>{{ t.prodBrndName }}</div>
                                <div>{{ t.prodName }}</div>
                                <div>{{ t.prodSizeText }}</div>
                                <div
                                    v-if="
                                        t.evntTckMltpQtyInd === 'Y' &&
                                            t.evntTckQty
                                    "
                                    class="my-2"
                                >
                                    {{
                                        `${$t('event.ticket.qty')}: ${
                                            t.evntTckQty
                                        }`
                                    }}
                                </div>
                            </div>
                            <div class="my-1">
                                {{ $t('event.ticket.number') }}
                                :
                                {{ t.evntTckNum }}
                            </div>
                            <div class="my-1">
                                {{ $t('event.ticket.purchase.date') }}
                                :
                                {{
                                    t.evntTckCreTs | formatDate('fullDateTime')
                                }}
                            </div>
                            <div
                                class="my-1 text-secondary underline"
                                @click="viewTicketContent(t)"
                            >
                                {{ '查看門票詳情' }}
                            </div>
                        </div>
                        <div
                            class="flex-grow flex flex-col items-center sm:items-stretch"
                        >
                            <div @click="zoomQrCode(t)" class="w-40">
                                <qrcode
                                    class=" w-40"
                                    :options="{ width: 160 }"
                                    :value="eventTicketVerifyUrl(t)"
                                />
                                <div
                                    class="text-sm text-center text-secondary underline"
                                >
                                    {{ '點擊放大二維碼' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex justify-center mt-4">
                    <pager
                        class="mx-auto"
                        :page="pager.page"
                        :recordsPerPage="pager.recordsPerPage"
                        :totalRecords="list.length"
                        @setPage="p => (pager.page = p)"
                    />
                </div>
            </div>
        </div>
        <div v-else class="w-full flex flex-col items-center">
            <div class="text-2xl text-black font-bold">
                {{ '並未持有電子門票' }}
            </div>
            <router-link
                class="btn border-0 font-black text-secondary mx-auto mt-8"
                tag="button"
                to="/"
            >
                <div class="icon">
                    <chevronLeft />
                </div>
                {{ $t('notFound.back.home') }}
            </router-link>
        </div>

        <modal
            type="custom"
            v-if="showQrcodeModal"
            :showDismiss="true"
            @backdrop="showQrcodeModal = false"
            class="modal-xl"
        >
            <div class="w-full">
                <div>
                    {{ $t('event.ticket.number') }}
                    :
                    {{ selectedTicket.evntTckNum }}
                </div>
                <qrcode
                    class="w-full"
                    :options="{ width: 500 }"
                    :value="eventTicketVerifyUrl(selectedTicket)"
                />
                <ul>
                    <li>
                        {{ '請向職員出示此二維碼' }}
                    </li>
                    <li>
                        {{ '請勿自行更改此門票為已使用，否則門票作廢' }}
                    </li>
                </ul>
            </div>
        </modal>
        <modal
            type="custom"
            v-if="showTicketDetailModal"
            :showDismiss="true"
            @backdrop="showTicketDetailModal = false"
            class="modal-4xl"
        >
            <div class="w-full ticket-detail-content">
                <div
                    v-if="loadingTicketContent"
                    class="my-8 flex justify-center"
                >
                    <spinner />
                </div>
                <div v-else v-html="selectedTicketContent"></div>
            </div>
        </modal>
    </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb.vue';
import pager from '../../components/pager.vue';
import spinner from '../../components/spinner.vue';
import formatDate from '../../components/formatDateFilter';
import qrcode from '../../components/qrcode.vue';
import modal from '../../components/modal.vue';
import chevronLeft from '../../assets/svg/chevron_left.svg';
import { instance } from '../../utils/ajax';
import sortBy from 'lodash/sortBy';

async function getTicketContent(token) {
    try {
        let result = await instance.get(
            `/api/eventTicket/ticketContent/${token}`
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error getting ticket content');
    }
    return undefined;
}

export default {
    components: {
        breadcrumb,
        pager,
        spinner,
        qrcode,
        modal,
        chevronLeft
    },
    filters: { formatDate },
    data() {
        return {
            loading: false,
            loadingTicketContent: false,
            pager: {
                page: 1,
                recordsPerPage: 10
            },
            showQrcodeModal: false,
            showTicketDetailModal: false,
            selectedTicket: undefined,
            selectedTicketContent: undefined,
            filter: 'active'
        };
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch('loadEventTicketList');
        this.loading = false;

        this.$watch('filter', () => {
            this.pager.page = 1;
        });
    },
    computed: {
        allEventTicketList() {
            return this.$store.state.eventTicketList || [];
        },
        list() {
            const sortedList = sortBy(this.allEventTicketList, [
                'evntTckCreTs'
            ]).reverse();
            if (this.filter === 'active') {
                return sortedList.filter(t => t.evntTckStsCode === 'A');
            }
            if (this.filter === 'inactive') {
                return sortedList.filter(t => t.evntTckStsCode !== 'A');
            }
            //all
            return sortedList;
        },
        recordsInPage() {
            const start = (this.pager.page - 1) * this.pager.recordsPerPage;
            return this.list.slice(start, start + this.pager.recordsPerPage);
        },
        hasTicket() {
            return (
                this.$store.state.eventTicketList &&
                this.$store.state.eventTicketList.length > 0
            );
        },
        eventTicketVerifyUrl() {
            return evntTck =>
                `${location.origin}${process.env.BASE_URL}eventTicketVerify/${evntTck.evntTckAccsTknNum}`;
        }
    },
    methods: {
        zoomQrCode(ticket) {
            this.selectedTicket = ticket;
            this.showQrcodeModal = true;
        },
        async viewTicketContent(ticket) {
            this.showTicketDetailModal = true;
            this.loadingTicketContent = true;
            const result = await getTicketContent(ticket.evntTckAccsTknNum);
            this.selectedTicketContent = result;
            this.loadingTicketContent = false;
        }
    }
};
</script>
